// extracted by mini-css-extract-plugin
export var askAiIcon = "_ka-9";
export var container = "_ka-0";
export var groupSeparator = "_ka-a";
export var highlight = "_ka-4";
export var resultIcon = "_ka-5";
export var resultItem = "_ka-7";
export var resultSubtitle = "_ka-3";
export var resultTitle = "_ka-2";
export var resultsList = "_ka-1";
export var searchGroup = "_ka-6";
export var selected = "_ka-8";